import { usePageContext } from "../../../hooks/context";
import type { OnboardingPackage } from "../../../types/package";
import { useChoosePackage } from "../hooks";

export const usePreSelectedPackage = (): OnboardingPackage | undefined => {
	const { availablePackages } = usePageContext(useChoosePackage);

	const preSelectedPackageId = sessionStorage.getItem("preSelectedPackage");
	const preSelectedPackage = availablePackages.find((p) => p?.packageId === preSelectedPackageId);

	return preSelectedPackage;
};
